import { render, staticRenderFns } from "./achievementMsg.vue?vue&type=template&id=ee465730&scoped=true&"
import script from "./achievementMsg.vue?vue&type=script&lang=js&"
export * from "./achievementMsg.vue?vue&type=script&lang=js&"
import style0 from "./achievementMsg.vue?vue&type=style&index=0&id=ee465730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee465730",
  null
  
)

export default component.exports